
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerEditor()
    export class PoCreditNoteAppEditors extends Serenity.LookupEditorBase<Serenity.LookupEditorOptions, PoCreditNoteAppRow>{

        constructor(hidden: JQuery) {
            super(hidden);
        }

        protected getLookupKey() {
            return PoCreditNoteAppRow.lookupKey;
        }

        // protected getItemText(item, lookup) {
        //     return super.getItemText(item, lookup) + ' [' + item.MbFirstName+']';
        // }
    }
}
